import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../redux/features/modalSlice";
import { FaEye, FaEdit, FaTrash,FaPlus } from 'react-icons/fa';
import { useCreateProductImageMutation } from "../../../redux/services/productService/product.Services";

import { successToast,errorToast } from "../../../Utils/toast";
import { useNavigate, useLocation,useParams  } from "react-router-dom";
function AddProductImages() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
const {state}=useLocation()
const product = state?.product;

const product_id = product?.id;
  const fileInputRef = useRef(null);

  // State
  const [imageRows, setImageRows] = useState([]);
  const [createProductImage, { isLoading }] = useCreateProductImageMutation();

const handleImageSelect = (e) => {
  const files = Array.from(e.target.files);
  const rows = files.map((file) => ({
    id: Date.now() + Math.random(),
    image: file,
    preview: URL.createObjectURL(file),
    title: "",
    order: "",
  }));

  setImageRows((prev) => [...prev, ...rows]);

  e.target.value = "";
};
  // Update row data
  const updateRow = (id, field, value) => {
    setImageRows((prev) =>
      prev.map((row) =>
        row.id === id ? { ...row, [field]: value } : row
      )
    );
  };

  // Remove image
  const removeImage = (id) => {
    setImageRows((prev) => {
      const updatedRows = prev.filter((row) => row.id !== id);
      // Revoke the preview URL
      const rowToRemove = prev.find((row) => row.id === id);
      if (rowToRemove) {
        URL.revokeObjectURL(rowToRemove.preview);
      }
      return updatedRows;
    });
  };

  // Submit
const handleSubmit = async (e) => {
  e.preventDefault();

  if (imageRows.length === 0) {
    errorToast("Please select at least one image");
    return;
  }

  try {
    const payload = new FormData();

    payload.append("product_id", id);

    imageRows.forEach((row) => {
      // title array
      payload.append(
        "image_titles",
        row.title || ""
      );

      // order array
      payload.append(
        "image_order",
        row.order || ""
      );

      // multiple files
      payload.append(
        "images",
        row.image
      );
    });

    const res = await createProductImage(payload).unwrap();

    if (res.success === 1) {
      successToast(res.message);

      dispatch(closeModal());

      navigate("/product-list");
    } else {
      errorToast(res.message);
    }
  } catch (error) {
    errorToast(
      error?.data?.message ||
      error?.message ||
      "Something went wrong"
    );
  }
};

  return (
    <div className="container py-4">
      {/* Header */}
       <div className="page-header-breadcrumb all_breadcrumb">
        <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
          <nav>
            <h4 className="fw-semibold">
              Add Images
            </h4>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <navigate to="/">
                  Home
                </navigate>
              </li>

              <li
                className="breadcrumb-item active"
                aria-current="page"
              >
                Add Images
              </li>

            </ol>

          </nav>

        </div>
        <div className="page-title fw-semibold fs-18 mb-0">

          <button
            className="btn btn-primary me-2"
            onClick={() => navigate(-1)}
          >

            <span>
              <i className="fe fe-shopping-cart me-1"></i>
            </span>

            Product List

          </button>

        </div>

      </div>

      <div className="card border-0 shadow rounded-4">
        <div className="card-body p-4">
          <form onSubmit={handleSubmit}>
            {/* Add Button */}
            <div className="mb-4">
              <button
                type="button"
                className="btn btn-lg btn-primary px-4 py-2"
                onClick={() => fileInputRef.current.click()}             
              >
                ➕ Add Image
              </button>

              <input
                ref={fileInputRef}
                type="file"
                hidden
                accept="image/*"
                multiple
                onChange={handleImageSelect}
              />
            </div>

            {/* Images Table/Rows */}
            {imageRows.length > 0 && (
              <div className="st-wrapper-card">
                <div className="st-table-responsive">

                <table className="table st-custom-table align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th >#</th>
                      <th >Image</th>
                      <th>Title</th>
                      <th>Order</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {imageRows.map((row, index) => (
                      <tr>
                        <td>
                          {index + 1}
                        </td>
                        <td>
                          <div className="imageproduct">
                            <img
                              src={row.preview}
                              alt="preview"
                             
                            />
                          </div>
                        </td>

                        {/* Title Input */}
                        <td>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder=""
                            value={row.title}
                            onChange={(e) => updateRow(row.id, "title", e.target.value)}
                          
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="1, 2, 3..."
                            value={row.order}
                            onChange={(e) => updateRow(row.id, "order", e.target.value)}
                            min="1"
                             />
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <button
                            type="button"
                            className="st-action-btn st-delete-btn"
                            onClick={() => removeImage(row.id)}
                           
                          >
                           <FaTrash />  
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                </div>
              </div>
            )}
            {imageRows.length === 0 && (
              <div
                className="text-center py-5"
                style={{
                  border: "2px dashed #dee2e6",
                  borderRadius: "12px",
                  backgroundColor: "#f8f9fa",
                }}
              >
                <p className="text-muted mb-0">
                  No images added yet
                </p>
              </div>
            )}
            <div className="d-flex gap-3 mt-4 pt-3">
              <button
                type="submit"
                disabled={isLoading || imageRows.length === 0}
                className="btn btn-success px-4 py-2"
                style={{
                  borderRadius: "8px",
                  fontSize: "16px",
                  fontWeight: "600",
                  boxShadow: "0 4px 12px rgba(25, 135, 84, 0.3)",
                }}
              >
                {isLoading ? " Uploading..." : "Save Images"}
              </button>

              <button
                type="button"
                onClick={() => dispatch(closeModal())}
                className="btn btn-outline-secondary px-4 py-2"
              >
               Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddProductImages;